<template>
  <div id="table1">
    <div class="title">
      <i class="iconfont icon-exe-sale-primary"
         style="color: aqua; font-size: 15px; margin-right: 5px"></i>
      <span style="font-size: 18px; font-weight: 'bold'">{{ title }}</span><dv-decoration-1 style="width: 100px; height: 20px" />
    </div>
    <div v-if="config.data.length === 0"
         class="no-data">暂无数据</div>
    <dv-scroll-board v-else
                     :config="config"
                     ref="scrollBoard"
                     style="width: 100%; height: 95%; font-size: 12px" />
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    tableData: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      config: {
        header: [
          '库区编码',
          '库区名称',
          // '期初库存',
          // '预警类型',
          // '预警时间',
          // '调和数量',
          // '调整数量',
          '预警次数'
        ],
        data: [],
        hoverPause: false, // 鼠标悬浮时暂停轮播
        rowNum: 6, // 表格行数
        headerHeight: 35, // 表头高度
        headerBGC: '#0f1325', // 表头背景颜色
        oddRowBGC: '#0f1325', // 奇数行背景颜色
        evenRowBGC: '#171c33', // 偶数行背景颜色
        index: true, // 是否开启序号
        indexHeader: '序号', // 序号名称
        // columnWidth: ['50'], // 表头宽度Array[x,x,x,x]
        waitTime: 6000, // 翻页时间
        carousel: 'page', // 滚动类型page为整页，默认为单条
        align: ['center', 'center', 'center', 'center'] // 对齐方式Array[x,x,x,x]
      }
    }
  },
  created () {
    // window.addEventListener("resize", () => {
    //   this.$refs["scrollBoard"].updateRows();
    // });
  },
  mounted () {
    window.addEventListener('resize', () => {
      this.$refs['scrollBoard'].updateRows()
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', () => {
      this.$refs['scrollBoard'].updateRows()
    })
  },
  methods: {
    clickRow (row) {
      console.log('row: ', row)
    }
  },
  watch: {
    tableData: {
      handler (val) {
        const tempArr = this.tableData.map(item => {
          const { areaCode, areaName, forewarningNum } = item
          return [areaCode, areaName, forewarningNum]
        })
        this.config = tempArr.length ? { ...this.config, data: tempArr } : { data: [] }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .dv-scroll-board .rows .ceil {
  font-size: 13px !important;
}
#table1 {
  width: 100%;
  height: 100%;
  padding: 10px;
  display: flex;
  flex-direction: column;
  .title {
    display: flex;
    span {
      color: #c3cbde;
      font-size: 15px;
      margin-right: 10px;
    }
  }
  .no-data {
    flex:1;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    color: #fff;
  }
}
</style>
